import Screen from '@shared/utils/screen';
import styled from 'styled-components';

const DescriptionTipContainer = styled.div<React.CSSProperties>`
  position: absolute;
  top: ${392 * Screen.widthRatio}px;
`;

export default DescriptionTipContainer;
